<template>
    <div class="p-2">
        <div v-if="!currentQuestion">
            <onboarding-question-index />
        </div>

        <div v-if="currentQuestion">
            <onboarding-question-edit :embedded="embedded" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { mapState } from "vuex";

import OnboardingQuestionEdit from "@/components/onboarding/questions/OnboardingQuestionEdit";
import OnboardingQuestionIndex from "@/components/onboarding/questions/OnboardingQuestionIndex";

export default {
    created() {
        this.$store.dispatch("questions/refresh");
    },
    computed: {
        ...mapState("questions", [
            "currentQuestion",
            "currentQuestions",
            "hasUnansweredQuestions",
        ]),
    },
    methods: {
        finished() {
            this.$store.dispatch("onboarding/status");
        },
    },
    components: {
        OnboardingQuestionEdit,
        OnboardingQuestionIndex,
    },
    props: ["embedded"],
};
</script>